<div class="client-details-container">
	<h3 class="header-text header-margin-bottom" i18n="@@addClientDetails-clientDetails">Client Details</h3>
</div>
<mat-divider></mat-divider>

<div class="form-layout">
	<div class="form-row">
		<mat-form-field
			subscriptSizing="dynamic"
			appearance="outline"
			class="thin-outline-input-field thin-input-text form-field-third"
		>
			<mat-label i18n="@@addClientDetails-firstName">First Name</mat-label>
			<input matInput [formControl]="firstNameControl" data-automation-id="client-first-name-input" />
		</mat-form-field>

		<mat-form-field
			subscriptSizing="dynamic"
			appearance="outline"
			class="thin-outline-input-field thin-input-text form-field-third"
		>
			<mat-label i18n="@@addClientDetails-lastName">Last Name</mat-label>
			<input matInput [formControl]="lastNameControl" data-automation-id="client-last-name-input" />
		</mat-form-field>

		<mat-form-field
			subscriptSizing="dynamic"
			appearance="outline"
			class="thin-outline-input-field thin-input-text form-field-third"
		>
			<mat-label i18n="@@addClientDetails-clientIDN">Client IDN</mat-label>
			<input matInput [formControl]="idnControl" data-automation-id="client-idn-input" />
		</mat-form-field>
	</div>

	<!-- Property Address Fields (read-only when coming from the property screen) -->
	@if (selectedProperty?.property) {
		<div class="form-row property-address-row">
			<mat-form-field
				subscriptSizing="dynamic"
				appearance="outline"
				class="thin-outline-input-field thin-input-text form-field-third disabled-light-gray-input"
			>
				<input
					matInput
					[value]="selectedProperty.property.address?.address1 || ''"
					placeholder="Street Address"
					i18n-placeholder="@@addClientDetails-streetAddress"
					disabled
					data-automation-id="property-address1-input"
				/>
			</mat-form-field>
			<mat-form-field
				subscriptSizing="dynamic"
				appearance="outline"
				class="thin-outline-input-field thin-input-text form-field-third disabled-light-gray-input"
			>
				<input
					matInput
					[value]="selectedProperty.property.address?.address2 || ''"
					placeholder="Apartment/Suite"
					i18n-placeholder="@@addClientDetails-apartmentSuite"
					disabled
					data-automation-id="property-address2-input"
				/>
			</mat-form-field>
			<mat-form-field
				subscriptSizing="dynamic"
				appearance="outline"
				class="thin-outline-input-field thin-input-text form-field-third disabled-light-gray-input"
			>
				<input
					matInput
					[value]="selectedProperty.property.address?.locality || ''"
					placeholder="City"
					i18n-placeholder="@@addClientDetails-city"
					disabled
					data-automation-id="property-city-input"
				/>
			</mat-form-field>
		</div>
	}

	@if (selectedProperty?.property) {
		<div class="form-row property-address-row">
			<mat-form-field
				subscriptSizing="dynamic"
				appearance="outline"
				class="thin-outline-input-field thin-input-text form-field-third disabled-light-gray-input"
			>
				<input
					matInput
					[value]="selectedProperty.property.address?.stateProvinceRegion || ''"
					placeholder="State"
					i18n-placeholder="@@addClientDetails-state"
					disabled
					data-automation-id="property-state-input"
				/>
			</mat-form-field>
			<mat-form-field
				subscriptSizing="dynamic"
				appearance="outline"
				class="thin-outline-input-field thin-input-text form-field-third disabled-light-gray-input"
			>
				<input
					matInput
					[value]="selectedProperty.property.address?.postalCode || ''"
					placeholder="Zip Code"
					i18n-placeholder="@@addClientDetails-zipCode"
					disabled
					data-automation-id="property-zip-input"
				/>
			</mat-form-field>
			<mat-form-field
				subscriptSizing="dynamic"
				appearance="outline"
				class="thin-outline-input-field thin-input-text form-field-third disabled-light-gray-input"
			>
				<input
					matInput
					[value]="selectedProperty.property.address?.countryCode || ''"
					placeholder="Country"
					i18n-placeholder="@@addClientDetails-country"
					disabled
					data-automation-id="property-country-input"
				/>
			</mat-form-field>
		</div>
	}
</div>
